import React from 'react';
import { motion } from 'framer-motion';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  className = '',
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={handleClick}
      disabled={disabled}
      className={`
        relative inline-flex h-7 w-[52px] rounded-[14px] transition-colors duration-200 ease-in-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A054] focus-visible:ring-offset-2
        ${checked ? 'bg-[#D4A054]' : 'bg-[#E0E0E0]'}
        ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
        ${className}
      `}
    >
      <motion.span
        className={`
          absolute top-0.5 h-6 w-6 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)]
          ${disabled ? '' : ''}
        `}
        animate={{
          left: checked ? 'calc(100% - 26px)' : '2px',
        }}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30,
          duration: 0.2,
        }}
      />
    </button>
  );
};

export default Toggle;
